import moment from "moment";

function convertTo12Hour(timeStr) {
  const [hours, minutes, seconds] = timeStr.split(':');
  const hour = parseInt(hours);
  const period = hour >= 12 ? 'pm' : 'am';
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour12}:${minutes}:${seconds} ${period}`;
}

const DateConvertIntoReal = (date, url) => {
    if(date) {
        let isoDate = date;
        let isoDate1 = moment(isoDate?.split("T")[0]).format("MMMM Do YYYY");
        let isoDate2 = "";
        if (isoDate?.includes("T")) {
            const timePart = isoDate?.split("T")[1]?.replace("Z", "");
            if (timePart) {
                if(url === "regular") {
                    isoDate2 = moment(timePart, "hh:mm:ss").format("hh:mm:ss a");
                } else if(url === "12 hour") {
                    const time12 = convertTo12Hour(timePart);
                    isoDate2 = time12;
                }
            };
        };
        return `${isoDate1}, ${isoDate2}`;
    } else {
        return "-";
    };
};

export default DateConvertIntoReal;